<template>
    <div>
        <v-layout row align-center justify-space-between class="header report-header">
            <v-btn flat dark :to="'/bot/' + activeBot.code">
                <v-icon class="mr-1">mdi-arrow-left-bold-circle-outline</v-icon>
                back
            </v-btn>
            <div style="font-size: 20px" class="report-title">Statistic</div>
            <div>
                <v-menu bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-layout align-center v-on="on" style="cursor: pointer" class="report-bot-list">
                            <span>{{ activeBot ? activeBot.name : '' }}</span>
                            <v-icon color="#fff">mdi-chevron-down</v-icon>
                        </v-layout>
                    </template>
                    <div style="max-height: 352px; overflow: auto;">
                        <v-list>
                            <v-list-tile
                                    v-for="bot in botList"
                                    :key="bot.code"
                                    @click="changeBot(bot)"
                                    :class="activeBot.code === bot.code ? 'active' : ''"
                            >
                                <v-list-tile-title>{{bot.name}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </div>
                </v-menu>
            </div>
        </v-layout>
        <v-container fluid grid-list-sm>
            <v-card class="pa-1">
                <v-layout class="d-none">
                    <v-flex xs3>
                        <v-select
                                v-model="supporter"
                                label="Supporter"
                                :items="supporterList"
                                disabled
                        ></v-select>
                    </v-flex>
                    <v-flex xs3>
                        <v-select
                                v-model="channel"
                                label="Channel"
                                :items="channelList"
                                disabled
                        ></v-select>
                    </v-flex>
                    <v-flex xs3>
                        <v-select
                                v-model="density"
                                label="Density"
                                :items="densityList"
                                disabled
                        ></v-select>
                    </v-flex>
                    <v-spacer></v-spacer>
<!--                    <v-btn color="secondary">Export</v-btn>-->
                </v-layout>
                <v-layout class="report-filter">
                    <v-flex xs3>
                        <v-select
                                v-model="interval"
                                label="Interval"
                                :items="intervalList"
                        ></v-select>
                    </v-flex>
                    <v-flex xs3>
                        <DatePicker
                                v-model="fromDate"
                                label="From Date"
                                :max="toDate"
                                :disabled="interval !== 'custom'"
                        ></DatePicker>
                    </v-flex>
                    <v-flex xs3>
                        <DatePicker
                                v-model="toDate"
                                label="To Date"
                                :min="fromDate"
                                :max="today"
                                :disabled="interval !== 'custom'"
                        ></DatePicker>
                    </v-flex>
                    <v-flex xs3 class="report-buttons">
                        <v-btn color="primary" @click="getStatistic" v-if="interval === 'custom'">Get Data</v-btn>
                        <v-btn color="primary" @click="exportExcel">Export Excel</v-btn>
                    </v-flex>
                </v-layout>
            </v-card>
            <v-card class="my-3">
                <v-data-table
                        :items="dataTableSort"
                        :headers="headers"
                        :pagination.sync="pagination"
                >
                    <template v-slot:items="props">
                        <tr :active="props.selected" @click="props.selected = !props.selected">
                            <td v-for="header of headers" :key="header.value">
                                <span v-if="header.$value">{{header.$value(props.item)}}</span>
                                <span v-else>{{props.item[header.value] || props.item.statistic[header.value]}}</span>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:headers="props">
                        <tr>
                            <th
                                    v-for="header in props.headers"
                                    :key="header.text"
                                    :class="[
                                        'column sortable',
                                        pagination.descending ? 'desc' : 'asc',
                                        header.value === pagination.sortBy ? 'active' : ''
                                    ]"
                                    @click="changeSort(header.value)"
                            >
                                <v-layout align-center style="height: 25px">
                                    <span>{{header.text}}</span>
                                    <v-menu open-on-hover bottom offset-y left v-if="header.tooltips">
                                        <template v-slot:activator="{ on }">
                                            <i class="mdi mdi-alert-circle info-icon ml-1" v-on="on"></i>
                                        </template>
                                        <div class="header-tooltips">
                                            <v-layout align-start>
                                                <v-icon small dark color="#4977EE" class="mr-1">
                                                    mdi-alert-circle
                                                </v-icon>
                                                {{header.tooltips}}
                                            </v-layout>
                                            <v-divider></v-divider>
                                            <v-layout justify-space-between class="pa-1 tooltips-info">
                                                <div>Max</div>
                                                <div>{{max[header.value]}}</div>
                                            </v-layout>
                                            <v-layout justify-space-between class="pa-1 tooltips-info">
                                                <div>Min</div>
                                                <div>{{min[header.value]}}</div>
                                            </v-layout>
                                            <v-layout justify-space-between class="pa-1 tooltips-info">
                                                <div>Average</div>
                                                <div>{{average[header.value]}}</div>
                                            </v-layout>
                                        </div>
                                    </v-menu>
                                    <v-icon small>mdi-arrow-up</v-icon>
                                </v-layout>
                                <div v-if="header.hasAverage" style="text-align: left">
                                    {{average[header.value]}}
                                </div>
                            </th>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-container>

        <div class="chat_view_loading" v-if="loadingDialog">
            <div class="loading_overlay"></div>
            <v-progress-circular indeterminate size="54" color="white"></v-progress-circular>
        </div>
    </div>
</template>

<script>
import StatisticService from "@/services/statistic.service";
import _ from 'lodash';
import moment from 'moment';
import DatePicker from "@/components/custom/DatePicker";
import BotService from "@/services/bot.service";
import XLSX from 'xlsx';
import ActionTypes from "@/store/ActionTypes";
import { mapState} from "vuex";
import StaffService from "@/services/staff.service";
import $const from "../../utils/const";

const DEFAULT_STATISTIC = {
    avg_chat_duration: 0,
    chat_duration: 0,
    forward: 0,
    joined: 0,
    message_sent: 0,
    missed: 0,
    response_time: 0,
    served: 0,
    total_assigned: 0,
    avg_wait_time: 0,
    wait_time: 0,
    qc_agree: 0,
    qc_disagree: 0,
    average_rating: 0,
    total_ready_time: 0,
};

export default {
    name: "Statistic",
    components: { DatePicker },
    data () {
        return {
            fromDate: moment().subtract(6, 'day').format('YYYY-MM-DD'),
            toDate: moment().format('YYYY-MM-DD'),
            today: moment().format('YYYY-MM-DD'),
            interval: '7days',
            density: 'daily',
            supporter: 'all',
            channel: 'all',
            activeBot: {},
            dataTable: [],
            average: { ...DEFAULT_STATISTIC },
            min: {},
            max: {},
            supporterList: [
                { text: 'All', value: 'all' }
            ],
            channelList: [
                { text: 'All', value: 'all' }
            ],
            densityList: [
                { text: 'Daily', value: 'daily' },
                { text: 'Weekly', value: 'weekly' },
                { text: 'Monthly', value: 'monthly' },
            ],
            intervalList: [
                { text: 'Last 7 days', value: '7days' },
                { text: 'Last 30 days', value: '30days' },
                { text: 'Custom', value: 'custom' }
            ],
            // botList: [
            //     { name: 'sddsfdf', code: 'ssdfdsdf' }
            // ],
            pagination: {
                rowsPerPage: 10,
                page: 1,
                sortBy: '',
                descending: true
            },
            loadingDialog: false,
            botList: []
        }
    },
    computed: {
      ...mapState('config', ['botConfig']),
      ...mapState(['user']),

      headers () {
            let headers = [
                {
                    text: 'Name',
                    value: 'name'
                },
                {
                    text: 'Email',
                    value: 'email'
                },
                // {
                //     text: 'Sent Messages (' + this.average.message_sent + ')',
                //     value: 'message_sent',
                //     $value: item => item.statistic.message_sent
                // },
                {
                    text: 'Served',
                    value: 'served',
                    $value: item => item.statistic.served,
                    tooltips: 'The number of times the supporter completes his task and marks the conversation with a customer as done',
                    hasAverage: true
                },
                {
                    text: 'Forward',
                    value: 'forward',
                    $value: item => item.statistic.forward,
                    hasAverage: true,
                    tooltips: 'The number of times the supporter forwards a conversation to the others'
                },
                {
                    text: 'Total Assigned Chats',
                    value: 'total_assigned',
                    $value: item => item.statistic.total_assigned,
                    hasAverage: true,
                    tooltips: 'The number of times the supporter is assigned a customer',
                },
                {
                    text: 'Total Online Time',
                    value: 'total_ready_time',
                    $value: item => this.formatTime(item.statistic.total_ready_time),
                    tooltips: 'The amount of time supporter turn on "Ready to receive request support"',
                    hasAverage: true,
                    isTime: false
                },
                // {
                //     text: 'Response Time',
                //     value: 'response_time',
                //     $value: item => this.formatTime(item.statistic.response_time),
                //     tooltips: 'Time which it takes for an agent to reply to a char message',
                //     hasAverage: true,
                //     isTime: true
                // },
                {
                    text: 'Average Wait time',
                    value: 'avg_wait_time',
                    $value: item => this.formatTime(item.statistic.wait_time / item.statistic.total_assigned),
                    tooltips: 'The average of time from when the supporter is assigned until he/she replies, or marks as done, or assigns to the others.',
                    hasAverage: true,
                    isTime: true
                },
                {
                    text: 'Total Wait time',
                    value: 'wait_time',
                    $value: item => this.formatTime(item.statistic.wait_time),
                    tooltips: 'The amount of time from when the supporter is assigned until he/she replies, or marks as done, or assigns to the others.',
                    hasAverage: true,
                    isTime: true
                },
                {
                    text: 'Average Chat duration',
                    value: 'avg_chat_duration',
                    $value: item => this.formatTime(item.statistic.chat_duration / item.statistic.total_assigned),
                    tooltips: 'Average Duration from the supporter\'s first response until he marks as done or assigns to the others',
                    hasAverage: true,
                    isTime: true
                },
                {
                    text: 'Total Chat duration',
                    value: 'chat_duration',
                    $value: item => this.formatTime(item.statistic.chat_duration),
                    tooltips: 'Duration from the supporter\'s first response until he marks as done or assigns to the others',
                    hasAverage: true,
                    isTime: true
                },
                {
                    text: 'Average Customer Rating',
                    value: 'average_rating',
                    $value: item => item.statistic.average_rating,
                    tooltips: 'Average rating of customer for each agent',
                    hasAverage: true,
                    isTime: false
                },
            ];
            if (this.botConfig['botEnableQualityControl'] === '1') {
              headers.push({
                text: 'QC Agree',
                value: 'qc_agree',
                $value: item => item.statistic.qc_agree,
                tooltips: 'Number of answer messages Quality Control agree',
                hasAverage: true,
                isTime: false
              })
              headers.push({
                text: 'QC Disagree',
                value: 'qc_disagree',
                $value: item => item.statistic.qc_disagree,
                tooltips: 'Number of answer messages Quality Control disagree',
                hasAverage: true,
                isTime: false
              })
            }
            for (let header of headers) {
                header.text = this.$filters.capitalize(header.text);
                header.sortable = true;
            }
            
            return headers;
        },
        dataTableSort () {
            if (this.pagination.sortBy) {
                let header = _.find(this.headers, item => item.value === this.pagination.sortBy);
                return _.orderBy(
                    this.dataTable,
                    item => item[header.value] || item.statistic[header.value],
                    this.pagination.descending ? 'desc' : 'asc'
                )
            }
            return this.dataTable
        },
    },
    mounted () {
        if(this.hasPermission()){
            BotService.getAllBot().then(
                result => {
                    this.botList = result.data;
                    let botCode = this.$route.params.botCode;
                    if (botCode) {
                        let bot = _.find(this.botList, bot => bot.code === botCode)
                        if (bot) {
                            this.selectBot(bot);
                        } else {
                            this.$router.push('/statistic');
                        }
                    } else if (this.botList.length > 0) {
                        this.selectBot(this.botList[0]);
                    }
                },
                this.$AppService.handleRequestError('can not get bot list')
            );
        }
        else{
            this.$router.push('/forbidden')
        }
    },
    methods: {
        changeBot (bot) {
            this.$store.commit(ActionTypes.BOT, bot)
            this.$router.push('/statistic/' + bot.code);
        },
        selectBot (bot) {
            this.activeBot = bot;
            this.getStatistic();
        },
        hasPermission(){
            return StaffService.checkStaffHasRoleFeature(this.$route.params.botCode, this.user.id, $const.ROLE_FEATURES.ACCESS_LIVE_SUPPORT_PAGE)
        },
        async getStatistic () {
            let botCode = this.$route.params.botCode;
            // open waiting dialog
            this.loadingDialog = true;
            await StatisticService.getStatistic(
                botCode,
                moment(this.fromDate).format('x'),
                moment(this.toDate).format('x'),
            ).then(
                result => {
                    let dataTable = result.data;
                    // fill data average
                    for (let u of dataTable) {
                        if (u.statistic.total_assigned > 0) {
                            u.statistic.avg_wait_time = u.statistic.wait_time / u.statistic.total_assigned;
                            u.statistic.avg_chat_duration = u.statistic.chat_duration / u.statistic.total_assigned;
                        } else {
                            u.statistic.avg_wait_time = 0;
                            u.statistic.avg_chat_duration = 0;
                        }
                    }

                    let average = { ...DEFAULT_STATISTIC };
                    let min = {};
                    let max = { ...DEFAULT_STATISTIC };
                    for (let user of dataTable) {
                        for (let i in average) {
                            average[i] += user.statistic[i];
                            if (!(i in min) || min[i] > user.statistic[i]) {
                                min[i] = user.statistic[i];
                            }
                            if (max[i] < user.statistic[i]) {
                                max[i] = user.statistic[i];
                            }
                        }
                    }
                    for (let k of Object.keys(DEFAULT_STATISTIC)) {
                        if (!(k in min)) {
                            min[k] = DEFAULT_STATISTIC[k];
                        }
                    }
                    for (let i in average) {
                        average[i] = Math.round(average[i] / dataTable.length * 100) / 100;
                    }


                    let timeList = ['avg_chat_duration', 'chat_duration', 'avg_wait_time', 'wait_time', 'response_time', 'total_ready_time'];
                    for (let i of timeList) {
                        min[i] = this.formatTime(Math.round(min[i]));
                        max[i] = this.formatTime(Math.round(max[i]));
                        average[i] = this.formatTime(Math.round(average[i]));
                    }
                    this.dataTable = dataTable;
                    this.average = average;
                    this.min = min;
                    this.max = max;

                    this.loadingDialog = false;
                },
                () => {
                    this.$AppService.handleRequestError('can not get statistic data');
                    this.loadingDialog = false;
                }
            );
        },

        formatTime (time) {
            // for time is NaN
            if (!time) {
                time = 0;
            }
            // round time
            time = Math.floor(time);

            let s = time % 60;
            let m = (time - s) / 60;
            let h = (m - m % 60) / 60;
            m = m % 60;
            s = s < 10 ? '0' + s : s;
            m = m < 10 ? '0' + m : m;
            h = h < 10 ? '0' + h : h;
            return h + ' : ' + m + ' : ' + s;
        },
        changeSort (headerValue) {
            let pagination = { ...this.pagination };
            if (pagination.sortBy === headerValue) {
                pagination.descending = !this.pagination.descending;
            } else {
                pagination.sortBy = headerValue;
                pagination.descending = true;
            }
            this.pagination = pagination;
            setTimeout(() => {
                this.$forceUpdate()
            }, 2000)
        },
        async exportExcel() {
            this.loadingDialog = true;
            try {
                await StatisticService.saveAuditExportStatistic(
                    this.$route.params.botCode,
                    moment(this.fromDate).format('x'),
                    moment(this.toDate).format('x'),)
            } catch (e) {
                this.$AppService.handleRequestError('Export KPI report failed');
                this.loadingDialog = false;
                return;
            }
            if (this.interval === 'custom') {
                await this.getStatistic();
            }
            let excel_headers = [
                [
                    "Name",
                    "Email",
                    // "Sent Messages",
                    "Served",
                    "Forward",
                    "Total Assigned Chats",
                    "Total Online Time",
                    // "Response time",
                    "Average Wait time",
                    "Total Wait time",
                    "Average Chat duration",
                    "Total Chat duration",
                    "QC Agree",
                    "QC Disagree",
                    "Average Customer Rating",
                ]
            ]
            let ws = XLSX.utils.aoa_to_sheet(excel_headers);
            ws["!cols"] = [
                {width: 30},
                {width: 30},
                {width: 8},
                {width: 8},
                {width: 19},
                {width: 22},
                {width: 16},
                {width: 15},
                {width: 19},
                {width: 16},
                {width: 16},
                {width: 16},
                {width: 22},
            ];

            let excel_data = [];
            for (let data of this.dataTable) {
                excel_data.push({
                    'name': data.name,
                    'email': data.email,
                    // 'message_sent': data.statistic.message_sent,
                    'served': data.statistic.served,
                    'forward': data.statistic.forward,
                    'total_assigned': data.statistic.total_assigned,
                    'total_ready_time': this.formatTime(data.statistic.total_ready_time),
                    // 'response_time': this.formatTime(data.statistic.response_time),
                    'avg_wait_time': this.formatTime(data.statistic.wait_time / data.statistic.total_assigned),
                    'total_wait_time': this.formatTime(data.statistic.wait_time),
                    'avg_chat_duration': this.formatTime(data.statistic.chat_duration / data.statistic.total_assigned),
                    'total_chat_duration': this.formatTime(data.statistic.chat_duration),
                    'qc_agree': data.statistic.qc_agree,
                    'qc_disagree': data.statistic.qc_disagree,
                    'average_rating': data.statistic.average_rating,
                })
            }
            XLSX.utils.sheet_add_json(ws, excel_data, {
                header:[
                    'name',
                    'email',
                    // 'message_sent',
                    'served',
                    'forward',
                    'total_assigned',
                    'total_ready_time',
                    // 'response_time',
                    'avg_wait_time',
                    'total_wait_time',
                    'avg_chat_duration',
                    'total_chat_duration',
                    'qc_agree',
                    'qc_disagree',
                    'average_rating',
                ],
                skipHeader:true,
                origin:-1
            });

            let wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "KPI");
            let fileName = this.$route.params.botCode + '_KPI_' + this.fromDate + '_' + this.toDate + '.xlsx'
            XLSX.writeFile(wb, fileName);
            this.loadingDialog = false;
        },
    },
    watch: {
        interval (val) {
            let get_statistic = false;
            switch (val) {
                case '7days' :
                    this.fromDate = moment().subtract(6, 'day').format('YYYY-MM-DD');
                    this.toDate = this.today;
                    get_statistic = true;
                    break;
                case '30days':
                    this.fromDate = moment().subtract(29, 'day').format('YYYY-MM-DD');
                    this.toDate = this.today;
                    get_statistic = true;
                    break;
                default:
                    break;
            }
            if (get_statistic) {
                this.getStatistic();
            }

        },
        "$route" () {
            let botCode = this.$route.params.botCode;
            if (botCode) {
                let bot = _.find(this.botList, bot => bot.code === botCode);
                if (bot) {
                    this.selectBot(bot);
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../components/style/variables.scss";
    .header {
        background: #2A4E69;
        color: #fff;
        padding: 0 15px;
    }

    ::v-deep table.v-table {
        thead th {
            padding: 12px 0 12px 12px;
        }

        tbody tr td {
            white-space: nowrap;
            padding: 12px 0 12px 12px;
        }
    }

    .header-tooltips {
        width: 240px;
        background: #1B3447;
        color: #fff;
        padding: 5px;

        &::v-deep hr {
            border-color: #2A4B64;
        }
    }

    .info-icon {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.54);;
        caret-color: rgb(73, 119, 238);
    }

    .tooltips-info {
        div:first-child {
            color: #00AFC8;
        }
    }

    ::v-deep .v-list .active {
        background: #ccc;
    }

    .chat_view_loading {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        z-index: 99999;
        align-items: center;
        text-align: center;
        padding-top: 27%;

        .loading_overlay {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            background-color: black;
            opacity: 0.2;
        }
    }
</style>
